const EMVatReport = Object.freeze({
    B2B: "em_vat_b2b_sales",
    DOMESTIC:"em_vat_domestic",
    EI_FACILITATION: "em_vat_ei_facilitation",
    FC_REP: "em_vat_fc_rep",
    OSS_UNION: "em_vat_oss_union",
    OSS_NON_UNION: "em_vat_oss_non_union",
    OSS_IMPORT: "em_vat_oss_import",
    GIFTCARD_SCHEME: "em_vat_gifts"
});

const StandardVATReportType = Object.freeze({
    B2B: 'B2B',
    DOMESTIC: 'DOMESTIC',
    EI_FACILITATION: 'EI_FACILITATION',
    FC_REP: 'FC_REP',
    OSS_UNION: 'OSS_UNION',
    OSS_NON_UNION: 'OSS_NON_UNION',
    OSS_IMPORT: 'OSS_IMPORT',
    GIFTCARD_SCHEME: 'GIFTCARD_SCHEME',
    NON_EU_COUNTRY_IMPORT: 'NON_EU_COUNTRY_IMPORT'
});

const VATCorrectionTable = Object.freeze({
    OSS_NON_UNION: "em_vat_report_vat_corrections_non_union",
    OSS_UNION: "em_vat_report_vat_corrections_union",
    OSS_IMPORT: "em_vat_report_vat_corrections_import",
    OSS_NON_EU_IMPORT: "em_vat_report_vat_corrections_non_eu_import"
});

const VATCorrectionTableSchema = Object.freeze({
    OSS_NON_UNION: "em_vat_corrections_non_union_view",
    OSS_UNION: "em_vat_corrections_union_view",
    OSS_IMPORT: "em_vat_corrections_import_view",
    OSS_NON_EU_IMPORT: "em_vat_corrections_non_eu_ioss_view"
});

const MIME_TYPE = {
    pdf : 'application/pdf',
    csv : 'text/csv',
    xlsx : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xml: 'text/xml'
}

const MAIL_STATUS = Object.freeze({
    DRAFT: 'draft',
    SENDING: 'sending',
    SENT: 'sent'
})

const CURRENCY_CODE_EUR = "EUR";

const REFRESH_TOKEN_STORAGE_KEY = 'q4us-auth.refreshToken';

module.exports = {
    EMVatReport,
    VATCorrectionTable,
    MIME_TYPE,
    MAIL_STATUS,
    CURRENCY_CODE_EUR,
    REFRESH_TOKEN_STORAGE_KEY,
    StandardVATReportType,
    VATCorrectionTableSchema
}